import { cancel, invoke, on } from "@hybird/core/bridge/hybirdBridge";
import { BridgeMethod } from "@hybird/core/bridge/core";

export class FlutterAdb extends BridgeMethod {
  constructor() {
    super();
  }

  async adbFindFiles( {
    onListen = null,
    onDone = null,
  } = {}) {
    return invoke("adbFindFiles", {
      params: {
      }, on: {
        "onListen": (params) => {
          onListen && onListen(params);
        },
        'onDone': (params) => {
          onDone && onDone(params)
        }
      }
    })
  }

  async completeWithFile({ hashCode }) {
    return invoke("completeWithFile", {
      params: {
        hashCode,
      },
    });
  }
  
  async findFiles({ names,maxConcurrent }) {
    return invoke("findFiles", {
      params: {
        names,
        maxConcurrent,
      },
    });
  }

  async findFilesCancel() {
    return invoke("findFilesCancel");
  }


  async adbPushFile({ src, dst }) {
    return invoke("adbPushFile", {
      params: {
        src,
        dst,
      },
    });
  }

  async deleteFile({ name, imgPath, jsonPath, type,videoPath }) {
    return invoke("deleteFile", {
      params: {
        name, imgPath, jsonPath, type,videoPath
      },
    });
  }

  async setSyncInfo({ status }) {
    return invoke("setSyncInfo",{
      params: {
        status,
      },});
  }

  async findAllFiles() {
    return invoke("findAllFiles");
  }


  /**
   * 获取ADB设备数量（只能连接一台设备）
   * @returns {Promise<{count: number}>}
   */
  async getAdbDeviceCount() {
    return await invoke("adbDeviceCount");
  }

  /**
   * 获取设备编号
   * @returns {Promise<{number: string}>}
   */
  async getAdbDeviceNumber() {
    return await invoke("adbDeviceNumber");
  }

  /**
   * 清理本地数据
   * @returns {Promise<{success: boolean}>}
   */
  async clearLocalAdbData() {
    return await invoke("clearLocalAdbData");
  }

  /**
   * 监听ADB设备状态变化
   * @param {Function} callback - 状态变化回调函数
   * @returns {Promise}
   */
  onAdbStateChange(callback) {
    return on("onAdbStateChange", (data) => {
      if (callback) {
        callback(data);
      }
    });
  }

  /**
   * 取消监听ADB设备状态变化
   * @returns {Promise}
   */
  offAdbStateChange() {
    return cancel("onAdbStateChange");
  }

  /**
   * 开始文件上传
   * @param {Object} options - 上传配置选项
   * @param {string} options.uploadUrl - 上传URL
   * @param {Function} options.onProgress - 进度回调
   * @param {Function} options.onError - 错误回调
   * @param {Function} options.onDone - 完成回调
   * @returns {Promise}
   */
  async startAdbFileUpload({ uploadUrl, onError, onProgress, onDone }) {
    return await invoke("startAdbFilesUpload", {
      params: {
        uploadUrl,
      },
      on: {
        onProgress,
        onError,
        onDone,
      },
    });
  }

  /**
   * 停止文件上传
   * @returns {Promise}
   */
  async stopAdbFileUpload() {
    return await invoke("closeAdbFilesUpload");
  }

  /**
   * 销毁实例，清理所有监听器
   */
  async destroy() {
    await this.offAdbStateChange();
    await this.stopAdbFileUpload();
  }
}
